import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { MatriculaDetail } from 'src/app/models/matricula.model';
import { AdjuntoService } from 'src/app/services/adjunto.service';
import { FaseService } from 'src/app/services/fase.service';
import { ProcesoMatriculaService } from 'src/app/services/procesomatricula.service';
import { ContratoecertService } from "src/app/services/contratoecert.service";

@Component({
  selector: 'app-borrador',
  templateUrl: './borrador.component.html',
  styleUrls: ['./borrador.component.css']
})
export class BorradorComponent implements OnInit, OnDestroy {
  MatriculaForm: FormGroup;
  //@Input() Alumno: Contact;
  //@Input() ProcesoMatricula: Panel;
  @Input() idProceso: string = '';
  @Input() faseActual: string = '';
  borradorSubcribe: Subscription;
  detalleMatricula: MatriculaDetail;
  cargandoDatos = true;
  idPago: any;
  cuotaMatricula: number = 0;
  montoMatricula: number = 0;
  valorCuotaMatricula: number = 0;

  montoCuotaArancel: number = 0;
  nroCuotaArancel: number = 0;
  montoCuotaMatri: number = 0;
  nroCuotaMatri: number = 0;
  monstrarTabla = false;
  @Output() Fase: EventEmitter<string> = new EventEmitter(); // avanzar la fase en el ribbon de fase
  @Output() UpdateDocumentos: EventEmitter<void> = new EventEmitter();

  MetodoFirma: any;
  constructor(
    private fb: FormBuilder,
    private faseservice: FaseService,
    private detalleservice: ProcesoMatriculaService,
    private alerts: ToastrService,
    private notas: AdjuntoService,
    private contratoecertservice: ContratoecertService
  ) {
    this.MatriculaForm = fb.group(
      {
        RUT: [''],
        Folio: [''],
        Nombre: [''],
        Apellido: [''],
        Institucion: [''],
        Sede: [''],
        Carrera: [' '],
        Jornada: [''],
        Montopagado: [''],
        NCuotas: [''],
        ValorCuota: ['']
      }
    );
    this.borradorSubcribe = faseservice.fase$.subscribe(value => {
      if (value == '7' || this.faseActual == '7') {

        this.MatriculaForm.controls.Montopagado.setValue('');
        this.MatriculaForm.controls.NCuotas.setValue('');
        this.MatriculaForm.controls.ValorCuota.setValue('');
        this.detalleservice.GetDetallePago(this.idProceso).subscribe((data: any) => {
          this.detalleMatricula = data.Result;
          this.MatriculaForm.controls.Jornada.setValue(this.detalleMatricula?.Jornada);
          this.MatriculaForm.controls.Folio.setValue(this.detalleMatricula?.Folio);
          this.MatriculaForm.controls.Montopagado.setValue(this.detalleMatricula?.MontoPagado);
          this.MatriculaForm.controls.NCuotas.setValue(this.detalleMatricula?.NroCuotas);
          this.MatriculaForm.controls.ValorCuota.setValue(this.detalleMatricula?.ValorCuotas);

          this.MatriculaForm.controls.RUT.setValue(this.detalleMatricula?.Rut);
          this.MatriculaForm.controls.Nombre.setValue(this.detalleMatricula?.Nombre);
          this.MatriculaForm.controls.Apellido.setValue(this.detalleMatricula?.Apellido);
          this.MatriculaForm.controls.Institucion.setValue(this.detalleMatricula?.Institucion);
          this.MatriculaForm.controls.Sede.setValue(this.detalleMatricula?.Sede);
          this.MatriculaForm.controls.Carrera.setValue(this.detalleMatricula?.Carrera);
          this.cuotaMatricula = Number.parseInt(this.detalleMatricula?.NroCuotas);
          this.montoMatricula = Number.parseInt(this.detalleMatricula?.MontoPagado);
          this.valorCuotaMatricula = Number.parseInt(this.detalleMatricula?.ValorCuotas)
          this.montoCuotaArancel = this.detalleMatricula?.MontoCuotaArancel;
          this.nroCuotaArancel = this.detalleMatricula?.NroCuotasArancel;
          this.montoCuotaMatri = this.detalleMatricula?.MontoCuotaMatri;
          this.nroCuotaMatri = this.detalleMatricula?.NroCuotasMatri;
          if (this.nroCuotaArancel > 0)
            this.monstrarTabla = true;

          this.MatriculaForm.controls.RUT.disable();
          this.MatriculaForm.controls.Nombre.disable();
          this.MatriculaForm.controls.Apellido.disable();
          this.MatriculaForm.controls.Institucion.disable();
          this.MatriculaForm.controls.Sede.disable();
          this.MatriculaForm.controls.Carrera.disable();
          this.MatriculaForm.controls.Montopagado.disable();
          this.MatriculaForm.controls.NCuotas.disable();
          this.MatriculaForm.controls.ValorCuota.disable();
          this.MatriculaForm.controls.Jornada.disable();
          this.MatriculaForm.controls.Folio.disable();
          this.MatriculaForm.controls.Montopagado.disable();
          this.MatriculaForm.controls.NCuotas.disable();
          this.MatriculaForm.controls.ValorCuota.disable();
          this.idPago = this.detalleMatricula?.idFile;
          this.cargandoDatos = false;
        }, (err) => {
          // This is intentional
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.borradorSubcribe.unsubscribe();
  }

  Descargar() {
    if (this.idPago === '00000000-0000-0000-0000-000000000000') {
      this.alerts.warning('El documento, no se encuentra disponible', 'Informe de matricula');
      return;
    }
    this.alerts.info('Se esta procesando la solicitud', 'Descargando informe de matricula');
    var fileId = this.idPago;
    this.notas.DescargarNotaCRM(fileId).subscribe((suc: any) => {
      console.log(suc);
      const file = new Blob([suc], { type: 'application/pdf' });

      this.saveAs(file, "Contrato_[" + this.MatriculaForm.controls.Institucion.value + "][" + this.MatriculaForm.controls.Sede.value + "][" + this.MatriculaForm.controls.Carrera.value + "][" + this.MatriculaForm.controls.Jornada.value + "][" + this.MatriculaForm.controls.RUT.value + "].pdf");
    })

  }

  ngOnInit(): void {
  debugger;
    // This is intentional
    this.faseservice.fase$.subscribe((value) => {
      debugger;
      if (value == "7") {
        debugger;
        this.contratoecertservice.getMetodoFirma().subscribe(
          (data: any) => {
            debugger;
            if (data.ECertActivo) {
              this.contratoecertservice
                .EnviarContrato(this.idProceso)
                .subscribe(
                  (data: any) => {
                    debugger;
                    if (data.Codigo != null) {
                      if (data.Codigo === 1) {
                        this.alerts.success(
                          "En tu correo electrónico encontrarás el contrato firmado.",
                          "Envío Contrato"
                        );
                      }
                    }
                  },
                  (err) => {}
                );
            }
          },
          (error) => {}
        );
      }
    });
  }

  saveAs(blob, fileName) {
    const url = window.URL.createObjectURL(blob);

    const doc = document.createElement('a');
    doc.href = url;
    doc.download = fileName;
    doc.click();
    window.URL.revokeObjectURL(url);
  }

  goToDocument() {
    console.log('[MATRICULA] go to document')
    this.UpdateDocumentos.emit();
  }
}
